<template>
	<section class="fac-card-accordion-item" :class="status ? 'active' : '' ">
		<div class="title" @click="requestOpen()">
			<div class="text">
				<!-- @slot Para inserir o título do card -->
				<slot name="title"></slot>
			</div>
			<div class="icon">
				<i class="fas" :class="status ? 'fa-chevron-up' : 'fa-chevron-down' "></i>
			</div>
		</div>
		
		<div class="content" v-show="status">
			<!-- @slot Para inserir o conteúdo do card -->
			<slot name="content"></slot>
		</div>
	</section>
</template>
<script>
	export default {
		name: 'ui-card-accordion-item',
        data() {
            return {
				status: false,
				id: null,
            }
		},
		methods:{
			setID(id) {
				this.id = id;
			},
			toggle(id){
				if(this.id === id && this.status === false){
					this.status = true
					return 
				}
				this.status = false
			},
			requestOpen(){
				this.$parent.$emit("request-open", this);
			},
		},
		mounted(){
			this.$nextTick(() => {
				this.$parent.$emit("register-card", this);
			})
			this.$parent.$on("toggle", this.toggle)
		}
    };
</script>
